<template>
  <div>
    <v-text-field
        label="Name"
        v-model="selectedOrganization.name"
    ></v-text-field>
    <v-text-field
        label="Short Name"
        v-model="selectedOrganization.shortName"
    ></v-text-field>
    <v-autocomplete
        v-model="selectedOrganization.clientLeads"
        :items="availableUsers"
        chips
        multiple
        label="Client leads"
        item-text="first_name"
        item-value="username">
      <template v-slot:selection="data">
        <v-chip
            v-bind="data.attrs"
            color="grey lighten-3"
            :input-value="data.selected"
            close
            @click="data.select"
            @click:close="remove(data.item)"
        >
          <v-avatar left>
            <v-img :src="data.item.avatar_url"></v-img>
          </v-avatar>
          {{ data.item.first_name }}
        </v-chip>
      </template>
      <template v-slot:item="data">
        <template v-if="typeof data.item !== 'object'">
          <v-list-item-content v-text="data.item"></v-list-item-content>
        </template>
        <template v-else>
          <v-list-item-avatar>
            <img :src="data.item.avatar_url">
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-html="data.item.first_name + ' ' + data.item.last_name"></v-list-item-title>
            <v-list-item-subtitle v-html="'@' + data.item.username"></v-list-item-subtitle>
          </v-list-item-content>
        </template>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>

import { getUsers } from '@/services/redbooth'

export default {
  name: "OrganizationDetails",
  data() {
    return {
      availableUsers: [],
      isUpdating: false,
    }
  },
  props: {
    selectedOrganization: {
      type: Object
    },
  },
  async created() {
    await getUsers().then(d => this.availableUsers = d);
  },
  watch: {
    isUpdating (val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    },
  },
  methods: {
    remove (item) {
      const index = this.selectedOrganization.clientLeads.indexOf(item.username);
      if (index >= 0) this.selectedOrganization.clientLeads.splice(index, 1)
    }
  },
}
</script>

<style scoped>

</style>